import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "header",
  class: "header-effect-shrink",
  "data-plugin-options": "{'stickyEnabled': true, 'stickyEffect': 'shrink', 'stickyEnableOnBoxed': true, 'stickyEnableOnMobile': true, 'stickyChangeLogo': true, 'stickyStartAt': 30, 'stickyHeaderContainerHeight': 80}"
}
const _hoisted_2 = { class: "header-body border-top-0" }
const _hoisted_3 = { class: "header-container container" }
const _hoisted_4 = { class: "header-row" }
const _hoisted_5 = { class: "header-column justify-content-start d-lg-none" }
const _hoisted_6 = { class: "header-row mt-2" }
const _hoisted_7 = { class: "header-logo" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  alt: "The Green Table",
  width: "247",
  height: "120",
  "data-sticky-width": "110",
  "data-sticky-height": "60",
  "data-sticky-top": "0",
  src: "/img-custom/logo-header.png"
}, null, -1)
const _hoisted_9 = { class: "header-column justify-content-center align-items-end" }
const _hoisted_10 = { class: "header-nav justify-content-lg-center p-0" }
const _hoisted_11 = { class: "header-nav header-nav-links" }
const _hoisted_12 = { class: "header-nav-main header-nav-main-square header-nav-main-dropdown-no-borders header-nav-main-dropdown-arrow header-nav-main-dropdown-center header-nav-main-dropdown-center-bottom header-nav-main-effect-3 header-nav-main-sub-effect-1" }
const _hoisted_13 = { class: "collapse" }
const _hoisted_14 = {
  id: "mainNav",
  class: "nav nav-pills flex-column flex-lg-row"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("li", { class: "order-1" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/it/categorie/" }, "Ricette")
], -1)
const _hoisted_16 = { class: "dropdown order-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item dropdown-toggle",
  href: "#"
}, [
  /*#__PURE__*/_createTextVNode(" Altro "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-down" })
], -1)
const _hoisted_18 = { class: "dropdown-menu" }
const _hoisted_19 = { class: "dropdown-submenu" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Utensili")
const _hoisted_21 = { class: "dropdown-submenu" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("La mia dispensa")
const _hoisted_23 = { class: "dropdown-submenu" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("La scelta vegetariana")
const _hoisted_25 = { class: "order-4" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Su di me")
const _hoisted_27 = { class: "order-5" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Contatti")
const _hoisted_29 = { class: "align-items-center d-none d-lg-flex order-3 px-5 mx-2" }
const _hoisted_30 = { class: "header-logo" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("img", {
  alt: "The Green Table",
  width: "247",
  height: "120",
  "data-sticky-width": "165",
  "data-sticky-height": "80",
  "data-sticky-top": "72",
  src: "/img-custom/logo-header.png"
}, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn header-btn-collapse-nav",
  "data-toggle": "collapse",
  "data-target": ".header-nav-main nav"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bars" })
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "header-column justify-content-end d-none d-lg-flex" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_RouterLink, { to: "/" }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("nav", _hoisted_13, [
                    _createElementVNode("ul", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("li", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("ul", _hoisted_18, [
                          _createElementVNode("li", _hoisted_19, [
                            _createVNode(_component_RouterLink, {
                              to: "/it/pagine/utensili/",
                              class: "dropdown-item"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_20
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("li", _hoisted_21, [
                            _createVNode(_component_RouterLink, {
                              to: "/it/pagine/la-mia-dispensa/",
                              class: "dropdown-item"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_22
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("li", _hoisted_23, [
                            _createVNode(_component_RouterLink, {
                              to: "/it/pagine/la-scelta-vegetariana/",
                              class: "dropdown-item"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_24
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_25, [
                        _createVNode(_component_RouterLink, { to: "/it/pagine/su-di-me/" }, {
                          default: _withCtx(() => [
                            _hoisted_26
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_27, [
                        _createVNode(_component_RouterLink, { to: "/it/contatti/" }, {
                          default: _withCtx(() => [
                            _hoisted_28
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_29, [
                        _createElementVNode("span", _hoisted_30, [
                          _createVNode(_component_RouterLink, {
                            to: "/it/",
                            class: "w-100 text-center"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_31
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ])
                ]),
                _hoisted_32
              ])
            ])
          ]),
          _hoisted_33
        ])
      ])
    ])
  ]))
}